import { useEffect, useState } from 'react';
import { HosApiDashboardVodPurchases } from '../../types/apiTypes';
import { DashboardCardTimespan, DashboardData } from '../../types/commonTypes';
import { useFetch } from '../useFetch';
import { useOperator } from '../../contexts/OperatorContext';
import { BASE_URL_MAP } from '../../lib/environment';

export const useVodPurchases = () => {
  const [vodPurchases, setVodPurchases] = useState<DashboardData[]>([]);
  const { makeRequest, loading, response } = useFetch();
  const operator = useOperator();

  useEffect(() => {
    if (response) setVodPurchases(mapVodPurchases(response));
  }, [response]);

  const getVodPurchases = (dateRange?: DashboardCardTimespan) => {
    let url = `${BASE_URL_MAP['Hospitality']}/${operator?.id}/Dashboard/BillingRecords`;
    if (dateRange)
      url += `?startDate=${dateRange.startDate.toISOString()}&endDate=${dateRange.endDate.toISOString()}`;

    makeRequest(url, 'get');
  };

  return { vodPurchases, getVodPurchases, loading };
};

const mapVodPurchases = (
  vodPurchase: HosApiDashboardVodPurchases
): DashboardData[] => {
  return [
    {
      id: 'Purchases',
      value: vodPurchase.Count,
    },
    {
      id: 'Revenue',
      value: vodPurchase.Revenue,
    },
  ];
};
